import { getAnalyticsPlugin } from '@/app/(main)/_components/logger/analytics/get-analytics-plugin';
import type { TrackProperties } from '@/app/(main)/_components/logger/analytics/plugins/analytics-plugin.types';
import { modalsOpeningStore } from '@/store/modal';
import { pendingSignupStore } from '@/store/pending-signup.store';
import { LoginAnalyticsEnum, LoginOriginEnum } from '@/types/enums/analytics/login/login-analytics.enum';

function withOrigin(origin: LoginOriginEnum | undefined, properties?: TrackProperties): TrackProperties {
  return origin ? { origin, ...properties } : { ...properties };
}

export function trackLoginModalEvent(event: LoginAnalyticsEnum, properties?: TrackProperties): void {
  getAnalyticsPlugin().track(event, withOrigin(modalsOpeningStore.getState().signInModalOrigin, properties));
}

export function trackSignupEvent(event: LoginAnalyticsEnum, properties?: TrackProperties): void {
  getAnalyticsPlugin().track(event, withOrigin(pendingSignupStore.getState().origin, properties));
}
